module.exports = __webpack_public_path__ + "static/img/son6_active.89b4afc4.png";